import React from "react";
import { Link } from "react-router-dom";
import { Compass, Home } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function NotFound() {
  const { t } = useLang();
  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <div className="mx-auto h-20 w-20 grid place-items-center rounded-2xl bg-findo-indigo/10 text-findo-indigo">
          <Compass size={40} />
        </div>
        <p className="mt-6 text-6xl font-display font-extrabold text-findo-navy">404</p>
        <h1 className="mt-2 text-xl font-display font-bold text-slate-900">{t("nf.title")}</h1>
        <p className="mt-2 text-slate-500">
          {t("nf.desc")}
        </p>
        <Link to="/" data-testid="not-found-home"
          className="mt-6 inline-flex items-center gap-2 rounded-xl bg-findo-indigo text-white font-semibold px-6 py-3 hover:bg-findo-indigo/90">
          <Home size={18} /> {t("nf.home")}
        </Link>
      </div>
    </div>
  );
}
